import { render, staticRenderFns } from "./AverageQaRoundsSection.vue?vue&type=template&id=087db30c&scoped=true&"
import script from "./AverageQaRoundsSection.vue?vue&type=script&lang=ts&"
export * from "./AverageQaRoundsSection.vue?vue&type=script&lang=ts&"
import style0 from "./AverageQaRoundsSection.vue?vue&type=style&index=0&id=087db30c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087db30c",
  null
  
)

export default component.exports